<div [formGroup]="parent">
  <div class="form-group has-float-label" formGroupName="orderHeader">
    <label class="form-label">Buyer</label>
    <input
      #buyerSOInput
      pInputText
      jniAutoCompleteBlocker
      autocomplete="off"
      type="text"
      id="buyer"
      name="buyer"
      class="form-control"
      [value]="buyerName"
      (input)="buyerVendor$.next($any($event.target).value)"
      (keyup)="onBuyerSearchOpenToggle(buyerPopOver, $event, buyerSOInput)"
      (keydown.Tab)="getBuyer($event, buyerPopOver)"
      (blur)="logValidationErrors()"
      (click)="onContactList(buyerPopOver, $event)"
      formControlName="buyer" />
  </div>
  <p-popover
    class="order-dropdown add"
    #buyerPopOver
    aria-labelledby="dropdownBasic1">
    <!-- <p-scroller style="height: 200px"> -->
    <p-table
      #dt
      stripedRows
      [size]="'small'"
      [value]="buyerLists"
      styleClass="p-datatable-customers order-listing"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="false"
      [resizableColumns]="true"
      [filterDelay]="0"
      [scrollable]="true"
      styleClass="table-listing"
      [scrollHeight]="'330px'">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th class="name">Buyer</th>
          <th class="client" pSortableColumn="client">
            Client
            <p-sortIcon field="Client"></p-sortIcon>
          </th>
          <th class="vaccount">Account</th>
          <th class="street">Street</th>
          <th class="city">City</th>
          <th class="state">State</th>
          <th class="lastOrderDate">Last order date</th>
        </tr>
        <tr>
          <th>
            <div class="d-flex">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                name="buyer"
                id="buyerFilter"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'buyer',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                name="organizationNameD365"
                id="organizationNameD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'organizationNameD365',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-buyerList let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row mousepointer"
          (click)="onBuyerSelection(buyerList, buyerPopOver)">
          <td class="buyer mousepointer">
            {{ buyerList.buyer }}
          </td>
          <td class="client mousepointer">
            {{ buyerList.organizationNameD365 }}
          </td>
          <td class="vaccount mousepointer">
            {{ buyerList.account }}
          </td>
          <td style="width: 200px" class="sname mousepointer">
            {{ buyerList.street }}
          </td>
          <td class="city mousepointer">{{ buyerList.city }}</td>
          <td style="width: 72px" class="state mousepointer">
            {{ buyerList.state }}
          </td>
          <td style="width: 75px" class="country mousepointer">
            {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No buyer found.</td>
        </tr>
      </ng-template>
    </p-table>
    <!-- </p-scroller> -->
  </p-popover>
</div>
